// extracted by mini-css-extract-plugin
export var name = "style-module__name___flDtK";